import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/superadmin/a11y")({
  // Component moved to superadmin.a11y.lazy.tsx for code splitting
});
